import { useEffect, useState } from "react";
import Button from "./ui/Button";
import { Input } from "./ui/Input";
import { Label } from "./ui/Label";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useForm } from "../hooks/useForm";
import { agregarSeleccion } from "../features/ui/uiSlice";
import {
  useAgregarLlamadaBusquedaMutation,
  useBuscarTramiteMutation,
} from "../services/docs";

import { encode } from "../hooks/code";
import { toastr } from "react-redux-toastr";
import { Spinner } from "./Spinner";
import { TablaBuscaPolizaComponent } from "./TablaBuscaPolizaComponent";
import { InputField } from "./ui/InputField";
import { Phone, Search, User } from "lucide-react";
import { Boton } from "./ui/Boton";

export const BuscarPolizaComponent = ({
  fc_telefono = "",
  fi_tipo_seguro = "",
  fc_tipo_base = "",
}) => {
  const [isNormal, setIsNormal] = useState(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [agregarLlamadaAction, { isLoading: cargando }] =
    useAgregarLlamadaBusquedaMutation();

  const { formulario, handleInputChange, handleChange } = useForm({
    fc_nombre: "",
    fc_apellidos_materno: "",
    fc_apellidos_paterno: "",
    fc_certificado: "",
    fd_nacimiento: "",
    fc_tipo_base: fc_tipo_base,
    fc_identificador_cliente: "",
    fc_telefono: "",
  });
  const verMas = async (p: any, t: any) => {
    let info = {
      tipo: t,
      id: p,
    };
    const ll = await agregarLlamadaAction({
      fc_telefono: fc_telefono,
      fi_tipo_seguro: +fi_tipo_seguro,
      ATMID: +p,
    })
      .unwrap()
      .catch((err: any) => {
        if (err.status === 400) {
          if (err.data.message) {
            if (Array.isArray(err.data.message)) {
              err.data.message.map((m: any) => {
                toastr.error(m);
                return;
              });
            } else {
              toastr.error(err.data.message);
              return;
            }
          }
        }
        toastr.error(err.message);
        return;
      });
    if (ll.status) {
      let cod = encode(info);
      dispatch(agregarSeleccion(cod));
      navigate(`/home/ver/informacion`);
    }
  };
  useEffect(() => {
    handleChange("fc_tipo_base", fc_tipo_base);
    if (fc_tipo_base === "SE") {
      setIsNormal(true);
    } else {
      setIsNormal(false);
    }
  }, [fc_tipo_base]);
  const [buscarTramiteAction, { data: pol, isLoading, error }] =
    useBuscarTramiteMutation();
  const buscarTramite = async () => {
    console.log(formulario);

    if (fc_telefono === "") {
      toastr.error("Debe de agregar número de teléfono");
      return;
    }
    if (fi_tipo_seguro === "") {
      toastr.error("Debe de seleccionar un tipo de Seguro");
      return;
    }
    if (fc_tipo_base === "SE") {
      if (
        formulario.fc_nombre === "" &&
        formulario.fc_apellidos_paterno === "" &&
        formulario.fc_apellidos_materno === "" &&
        formulario.fc_certificado === "" &&
        formulario.fd_nacimiento === ""
      ) {
        toastr.error("Debe seleccionar un tipo de búsqueda");
        return;
      }
    } else {
      if (
        formulario.fc_nombre === "" &&
        formulario.fc_apellidos_paterno === "" &&
        formulario.fc_apellidos_materno === "" &&
        formulario.fc_identificador_cliente === "" &&
        formulario.fc_telefono === "" &&
        formulario.fd_nacimiento === ""
      ) {
        toastr.error("Debe seleccionar un tipo de búsqueda");
        return;
      }
    }
    await buscarTramiteAction({
      ...formulario,
    }).unwrap();
  };
  return (
    <>
      <div className="flex flex-col gap-6 rounded-2xl border border-slate-100 bg-white p-8 shadow-sm">
        <div className="flex items-center gap-3 border-l-4 border-metric-blue-700 pl-4">
          <h2 className="font-manrope text-lg font-bold text-slate-900">
            Buscar Póliza
          </h2>
        </div>
        <div className="grid grid-cols-2 place-items-stretch gap-6">
          <InputField
            value={formulario.fc_nombre}
            onChange={handleInputChange}
            name="fc_nombre"
            label="Nombre(s):"
            placeholder=""
            icon={User}
          />
          <InputField
            value={formulario.fc_apellidos_paterno}
            onChange={handleInputChange}
            name="fc_apellidos_paterno"
            label="Apellido Paterno:"
            placeholder=""
            icon={User}
          />
          <InputField
            value={formulario.fc_apellidos_materno}
            onChange={handleInputChange}
            name="fc_apellidos_materno"
            label="Apellido Materno:"
            placeholder=""
            icon={User}
          />

          <InputField
            value={formulario.fd_nacimiento}
            onChange={handleInputChange}
            name="fd_nacimiento"
            label="Fecha Nacimiento:"
            placeholder={!isNormal ? "YYYYMMDD" : "DD/MM/YYYY"}
            icon={User}
          />

          {!isNormal && (
            <>
              <InputField
                value={formulario.fc_identificador_cliente}
                onChange={handleInputChange}
                name="fc_identificador_cliente"
                label="Indentificador Cliente:"
                placeholder=""
                icon={User}
              />
              <InputField
                value={formulario.fc_telefono}
                onChange={handleInputChange}
                name="fc_telefono"
                label="Teléfono:"
                placeholder=""
                icon={Phone}
              />
            </>
          )}
          {isNormal && (
            <>
              <InputField
                value={formulario.fc_certificado}
                onChange={handleInputChange}
                name="fc_certificado"
                label="Certificado:"
                placeholder=""
                icon={User}
              />
            </>
          )}
          <div>
            <div className="mt-6 flex flex-col px-6 py-2">
              <Boton icon={Search} onClick={buscarTramite}>
                Buscar
              </Boton>
            </div>
          </div>
        </div>
      </div>
      {isLoading && (
        <div className="mt-3 flex w-full justify-center">
          <Spinner />
        </div>
      )}
      {pol && pol.polizas && pol.polizas.length > 0 && (
        <div className="card col-span-2">
          <div className="mt-10 grid grid-cols-1 place-items-stretch gap-4">
            <TablaBuscaPolizaComponent
              data={pol.polizas}
              texto_accion="Ver mas"
              accion={verMas}
              ejecutivos={[]}
              cargando={false}
              action_cargando={cargando}
            />
          </div>
        </div>
      )}
      {pol && pol.polizas && pol.polizas.length === 0 && (
        <div className="card ">
          <div className="mt-10 grid grid-cols-1 place-items-stretch gap-4">
            <div className="my-4 rounded bg-danger py-2 text-center text-white">
              No se encontraron datos
            </div>
          </div>
        </div>
      )}
    </>
  );
};
